import { render, staticRenderFns } from "./TaskCombo.vue?vue&type=template&id=59ea0ff0"
import script from "./TaskCombo.vue?vue&type=script&lang=js"
export * from "./TaskCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports